export enum QueryKeys {
  BRANDS = 'brands',
  USERS = 'users',
  ROLES = 'roles',
  CHANNELS_ADDONS = 'channels_addons',
}
